import { setGlobalHeader } from '@/src/utils/fetch';
import vtkURLExtract from '@kitware/vtk.js/Common/Core/URLExtract';
import { UrlParams } from '@vueuse/core';

let authorizationTokenPromise: Promise<void> | undefined;

export function stripTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const url = new URL(window.location.toString());
  params.delete('token');
  url.search = `?${params.toString()}`;
  window.history.replaceState(null, '', url.toString());
}

// Every data entry point awaits the same initialization so child components
// cannot send a DICOMweb request before the asynchronous token URL resolves.
export function populateAuthorizationToken(
  urlParams?: UrlParams
): Promise<void> {
  if (!urlParams) {
    authorizationTokenPromise ??= initializeAuthorizationToken(
      vtkURLExtract.extractURLParameters() as UrlParams
    );
    return authorizationTokenPromise;
  }
  return initializeAuthorizationToken(urlParams);
}

async function initializeAuthorizationToken(urlParams: UrlParams) {
  if (urlParams.token) {
    setGlobalHeader('Authorization', `Bearer ${urlParams.token}`);
  }

  if (urlParams.tokenUrl) {
    try {
      const response = await fetch(String(urlParams.tokenUrl), {
        method: String(urlParams.tokenUrlMethod || 'GET'),
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error(`received ${response.status} response`);
      }
      setGlobalHeader('Authorization', `Bearer ${await response.text()}`);
    } catch (err) {
      console.error('error while fetching token from tokenUrl:', err);
    }
  }
}
